/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3f7fe8648d311ffe53fe62f0ab6eb24>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "ListNumbered".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Numbered list in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const ListNumberedIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H5V2h10zm0 5.25H5v-1.5h10zM15 14H5v-1.5h10z" clip-rule="evenodd"/><path fill="currentcolor" d="M2.02 8.22.75 9.44v.98h2.81V9.38H2.31l.38-.35q.42-.38.62-.76a1.65 1.65 0 0 0 .2-.79c0-.25-.06-.48-.18-.67a1.2 1.2 0 0 0-.5-.44 1.55 1.55 0 0 0-.72-.16q-.43 0-.77.17t-.52.49-.18.73v.17h1.12v-.16c0-.14.04-.22.09-.27a.34.34 0 0 1 .25-.09c.11 0 .18.03.22.08.05.05.08.12.08.24a.56.56 0 0 1-.09.3q-.09.15-.29.35m-.25-6v1.94H.81v1.01h2.85V4.15h-.77V1H1.81L.8 1.71v1.23zm-.42 13.35q.33.15.75.15t.75-.15.51-.45q.19-.3.18-.67v-.32c0-.38-.13-.7-.4-.94a1.3 1.3 0 0 0-.37-.22l.62-.55v-.92H.84v.99h1.15l-.5.44v.92h.62c.13 0 .2.03.25.08.04.04.08.1.08.21v.32c0 .11-.03.17-.07.21s-.12.07-.26.07c-.13 0-.21-.03-.26-.07-.04-.04-.07-.11-.07-.21v-.16H.66v.17c0 .25.06.48.18.68q.19.29.51.44"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
ListNumberedIcon.displayName = 'ListNumberedIcon';
var _default = exports.default = ListNumberedIcon;